import React, { useState, useEffect, useContext } from "react";

import {

  Modal,

  ModalOverlay,

  ModalContent,

  ModalHeader,

  ModalCloseButton,

  ModalBody,

  ModalFooter,

  Button,

  FormControl,

  FormLabel,

  Input,

  Select,

  Stack,

  useToast,

} from "@chakra-ui/react";

import Multiselect from "multiselect-react-dropdown";

import { appRequest } from "routes";

import { setDate } from "date-fns";
import { AppContext } from "AppProvider/AppContext";

// import MultiSelect from "../MultiSelect";

// import Multiselect from "multiselect-react-dropdown";

// import Select, { ValueType } from "react-select";



type ModalProps = {

  isOpen: boolean;

  onClose: () => void;

  handleGetUserRoles: () => void;

  type: string;

  data?: RoleTemplateValues;

};



type RoleFormErrors = {

  name?: string;
  role?: string;

  permissions?: string;

};



const options = [

  { value: "option1", label: "Option 1" },

  { value: "option2", label: "Option 2" },

  { value: "option3", label: "Option 3" },

];



type RoleFormValues = {

  template: string;

  name: string;
  role: string;

  permissions: string;

};



type RoleTemplateValues = {

  _id?: string;

  name: string;

  permissions: string[];

  role?: string;

}

// const options: Option[] = [

//   { value: "option1", label: "Option 1" },

//   { value: "option2", label: "Option 2" },

//   { value: "option3", label: "Option 3" },

//   // Add more options as needed

// ];





export default function RolesModal({
  isOpen,
  onClose,
  handleGetUserRoles,
  type,
  data
}: ModalProps): JSX.Element {

  const { toastNotify } = useContext(AppContext);

  useEffect(() => {
    setValues({
      name: "",
      role: "",
      permissions: [],
    })
  }, [onClose]);


  const [values, setValues] = useState<RoleTemplateValues>({
    name: data?.name || "",
    role: data?.role || "",
    permissions: data?.permissions || [],
  });

  const [preSelected, setPreSelected] = useState<object[]>(data?.permissions?.map((permission: any) => { return ({ key: permission, label: permission }) }) || []);

  useEffect(() => {
    if (data) {
      setValues({
        name: data.name,
        role: data.role,
        permissions: data.permissions
      })
      setPreSelected(data?.permissions?.map((permission: any) => { return ({ key: permission, label: permission }) }) || []);
    }
  }, [data]);



  // const [role, setRole] = useState<RoleTemplateValues[]>([]);
  const [permissions, setPermissions] = useState<object[]>([]);

  const [isDisabled, setIsDisabled] = useState<boolean>(type === 'View' ? true : false);

  const [errors, setErrors] = useState<RoleFormErrors>({});

  const [selectedOption, setSelectedOption] = useState<any | null>(null);

  useEffect(() => {
    if (data) {
      setValues({
        name: data.name,
        role: data.role,
        permissions: data.permissions,
      });
      setPreSelected(
        data?.permissions?.map((permission: any) => {
          return { key: permission, label: permission };
        }) || []
      );
    }
  }, [data]);

  const [role, setRole] = useState<RoleTemplateValues[]>([]);






  const validateRolesAndPermissions = () => {

    if (!values.name) {

      setErrors((prevErrors) => ({

        ...prevErrors,

        name: "At least one role is required",

      }));

    } else {

      setErrors((prevErrors) => ({ ...prevErrors, name: undefined }));

    }



    if (!values.permissions) {

      setErrors((prevErrors) => ({

        ...prevErrors,

        permissions: "At least one permission is required",

      }));

    } else {

      setErrors((prevErrors) => ({ ...prevErrors, permissions: undefined }));

    }

  };

  //* handle submit form for role and permission



  const handleGetRoles = async () => {

    try {

      const response: any = await appRequest("userrole", "get", {});
      if (response) {
        if (Array.isArray(response)) {
          setRole(response)
        } else {
          setRole([])
        }
      } else {
        toastNotify({
          title: `Error getting the roles templates`,
          description: response.message || "Something went wrong.",
          status: 'error',
          duration: 9000,
          isClosable: true,
          position: 'top-right'
        })
      }
    } catch (error: any) {

      toastNotify({

        title: `Error getting the roles templates.`,

        description: error.message || "Something went wrong.",

        status: 'error',

        duration: 9000,

        isClosable: true,

        position: 'top-right'

      })

    }

  }



  useEffect(() => {

    handleGetRoles();
    handleGetUserRoles();

  }, [])



  const handleSubmit = async (event: React.FormEvent<HTMLButtonElement>) => {

    event.preventDefault();

    validateRolesAndPermissions();

    // Validation

    if (!values.role) {

      setErrors((prevErrors: any) => ({ ...prevErrors, template: 'Role  is required' }));

    }

    if (!values.name) {

      setErrors((prevErrors: any) => ({ ...prevErrors, name: 'Role name is required' }));

    }

    if (!values.permissions) {

      setErrors((prevErrors: any) => ({ ...prevErrors, permissions: 'Role permission is required' }));

    }

    // If there are no errors, submit the form

    if (!errors.name && !errors.permissions) {

      // Submit form

      const input = {

        id: data?._id,

        name: values.name,

        permissions: values.permissions,

        role: values.role

      };



      try {

        const response: any = await appRequest('userrole', type === 'Add' ? "create" : "update", input);



        if (response && response.status === 'success') {

          toastNotify({

            title: 'Role created.',

            description: "We've created a new role for you.",

            status: 'success',

            duration: 9000,

            isClosable: true,

            position: 'top-right',

          });

          handleGetUserRoles();

          onClose();

        } else {

          toastNotify({

            title: 'Error creating role.',

            description: response?.message || 'Something went wrong.',

            status: 'error',

            duration: 9000,

            isClosable: true,

            position: 'top-right',

          });

        }

      } catch (error: any) {

        console.log(error);

        toastNotify({

          title: 'Error creating role.',

          description: error?.message || 'Something went wrong.',

          status: 'error',

          duration: 9000,

          isClosable: true,

          position: 'top-right',

        });

      }

    }

  };

  //*submission ends



  const handleChange = (

    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>

  ) => {

    const { name, value } = event.target;

    if (name === 'role') {

      let currentPermissions = role.find((item) => item._id === value)?.permissions || [];

      let multiSelect = currentPermissions?.map((item, index) => {

        return { cat: "Group 1", key: item }

      })

      setPermissions(multiSelect);

      setPreSelected([]);

    }

    setValues((prevValues) => ({ ...prevValues, [name]: value }));

  };



  const handleSelected = (selectedList: any, selectedItem: any) => {

    if (selectedList.length > 1) {

      // Display a toast notification if more than one permission is selected

      toastNotify({

        title: "Error",

        description: "You can only select one permission at a time.",

        status: "error",

        duration: 5000, // Adjust the duration as needed

        isClosable: true,

        position: "top-right",

      });



      // Reset the selected option to the previously selected one

      setSelectedOption(selectedList[0] || null);

      setPreSelected(selectedList);

      return;

    }



    // Update the selected option and preSelected state with the selected option

    setSelectedOption(selectedList[0] || null);

    setPreSelected(selectedList);

    setValues((prevValues) => ({ ...prevValues, permissions: selectedList.map((item: any) => item.key) }));

  };





  return (

    <Modal isOpen={isOpen} onClose={onClose} size={"lg"} isCentered>

      <ModalOverlay />

      <FormControl>

        <ModalContent>

          <ModalHeader

            color="teal.300"

            fontSize={{ base: "lg", md: "2xl" }}

            fontWeight="700"

          >

            {type} Roles

          </ModalHeader>

          <ModalCloseButton />

          <ModalBody>

            <form>

              <Stack spacing={4}>

                <FormControl id="roleName">

                  <FormLabel color="gray.700">Name</FormLabel>

                  <Input

                    type="text"

                    placeholder="Enter Name"

                    name="name"

                    value={values.name}

                    onChange={handleChange}

                    isDisabled={isDisabled}

                  />

                </FormControl>



                <FormControl id="roleTemplate">

                  <FormLabel color="gray.700">

                    Select Role

                  </FormLabel>

                  <Select

                    placeholder="Select Role"

                    name="role"

                    value={values.role}

                    onChange={handleChange}

                    onClick={handleGetRoles}

                    isDisabled={isDisabled}

                  >

                    {role && role.map((item: any) => (

                      <option key={item.id} value={item._id}>{item.name}</option>

                    ))}

                    {/* <option value="test1">Test 1</option>

                    <option value="test2">Test 2</option>

                    <option value="test3">Test 3</option> */}



                  </Select>

                </FormControl>

                <FormControl id="rolePermission">

                  <FormLabel color="gray.700">Select Permission</FormLabel>



                  {/* <MultiSelect

                  name="rolePermission"

                  options={options}

                  value={values.rolePermission}

                  onChange={handleChange}

                /> */}

                  {/* onChange={handleSelectChange} */}



                  {/* <Select

                  options={options}

                  value={selectedOptions}

                  onChange={handleSelectChange}

                  isMulti

                  placeholder="Select options"

                /> */}



                  {/* <Select

                  options={options}

                  value={selectedOptions}

                  onChange={handleSelectChange}

                  isMulti

                  placeholder="Select options"

                /> */}

                  <Multiselect

                    disablePreSelectedValues={false}
                    displayValue="key"
                    onKeyPressFn={function noRefCheck() { }}
                    onRemove={handleSelected}
                    onSearch={function noRefCheck() { }}
                    onSelect={handleSelected}
                    selectedValues={preSelected}
                    options={permissions}
                    showCheckbox
                    disable={isDisabled}

                    // options={[

                    //   {

                    //     cat: "Group 1",

                    //     key: "Level 1",

                    //   },

                    //   {

                    //     cat: "Group 1",

                    //     key: "Level 2",

                    //   },

                    //   {

                    //     cat: "Group 1",

                    //     key: "Level 3",

                    //   },

                    // ]}



                  />

                </FormControl>

              </Stack>

            </form>

          </ModalBody>

          <ModalFooter gap={6} mt={2}>

            <Button type="submit" w="80px" colorScheme="red" onClick={onClose}>

              Cancel

            </Button>

            <Button

              bg="teal.300"

              color="white"

              type="submit"

              onClick={handleSubmit}

              w="80px"

              fontWeight="500"

              _hover={{

                bg: "teal.400",

              }}

              isDisabled={isDisabled}

            >
              Save
            </Button>

          </ModalFooter>

        </ModalContent>

      </FormControl>

    </Modal>

  );

}



